import { SolanaWithoutSignerBaseCommand } from '../../../../solana';
import { chalkString } from '../../../../utils';

import { web3 } from '@coral-xyz/anchor';
import * as anchor from '@coral-xyz/anchor';
import { Args } from '@oclif/core';
import { toUtf8 } from '@switchboard-xyz/common';
import { PullFeed, PullFeedAccountData } from '@switchboard-xyz/on-demand';

export default class FeedPrint extends SolanaWithoutSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'print a feed account';

  static flags = {
    ...SolanaWithoutSignerBaseCommand.flags,
  };

  static args = {
    feedKey: Args.string({
      description: 'public key of the feed account',
      required: true,
    }),
  };

  async run() {
    const { args } = await this.parse(this.constructor as typeof FeedPrint);

    // const program = await this.program;
    const PROGRAM_ID = new web3.PublicKey(
      'SBondMDrcV3K4kxZR1HNVT7osZxAHVHgYXL5Ze1oMUv'
    );
    const RPC_URL = 'https://eclipse.helius-rpc.com'; // or your cluster
    const connection = new web3.Connection(RPC_URL, 'confirmed');

    // Use a dummy wallet if you don't need to sign
    const keypair = web3.Keypair.generate();
    const wallet = new anchor.Wallet(keypair);
    const provider = new anchor.AnchorProvider(connection, wallet, {});
    const idl = await anchor.Program.fetchIdl(PROGRAM_ID, provider);
    const program = new anchor.Program(idl!, provider);

    const feedPubKey = new web3.PublicKey(args.feedKey);

    const feedAccount = new PullFeed(program, feedPubKey);
    const feed = await feedAccount.loadData();

    console.log(this.printFeedRecap(feedAccount.pubkey, feed, 36));
  }

  printFeedRecap(
    publicKey: web3.PublicKey,
    feed: PullFeedAccountData,
    SPACING = 36
  ): string {
    this.normalizeAccountData(publicKey, feed);

    const output: string[] = [];

    output.push('', chalkString('## Feed Data', '', SPACING));
    output.push(chalkString('Feed PubKey', publicKey, SPACING));
    output.push(chalkString('authority', feed.authority.toString(), SPACING));
    output.push(chalkString('queue', feed.queue.toString(), SPACING));
    output.push(
      chalkString(
        'feedHash',
        Buffer.from(feed.feedHash).toString('hex'),
        SPACING
      )
    );
    output.push(
      chalkString('initializedAt', feed.initializedAt.toString(), SPACING)
    );
    output.push(
      chalkString('permissions', feed.permissions.toString(), SPACING)
    );
    output.push(
      chalkString('maxVariance', feed.maxVariance.toString(), SPACING)
    );
    output.push(
      chalkString('minResponses', feed.minResponses.toString(), SPACING)
    );
    output.push(chalkString('name', toUtf8(feed.name), SPACING));
    // output.push(chalkString('sampleSize', feed.sampleSize.toString(), SPACING));
    output.push(
      chalkString(
        'lastUpdateTimestamp',
        feed.lastUpdateTimestamp.toString(),
        SPACING
      )
    );
    output.push(chalkString('lutSlot', feed.lutSlot.toString(), SPACING));
    output.push(chalkString('result', JSON.stringify(feed.result), SPACING));
    output.push(
      chalkString('maxStaleness', feed.maxStaleness.toString(), SPACING)
    );
    output.push(
      chalkString('minSampleSize', feed.minSampleSize.toString(), SPACING)
    );
    output.push(
      chalkString(
        'historicalResultIdx',
        feed.historicalResultIdx.toString(),
        SPACING
      )
    );

    return output.join('\n');
  }

  async catch(error: Error) {
    super.catch(error, 'failed to print feed');
  }
}
